import React from 'react';
import DropdownMenu from "../desktop-components/ApplicationMenubar";
import '../applications-css/Application.css'
import "../applications-css/Notepad.css";

class Notepad extends React.Component {
  constructor(props) {
    super(props);
    let filename = this.props.filename;
    if(filename != null) {
      filename = this.extensionStripper(filename);
    }
    this.state = {
      filename: filename,
      fontSize: 12,
    }
    this.newFile = this.newFile.bind(this);
    this.newFileHandler = this.newFileHandler.bind(this);
    this.openFile = this.openFile.bind(this);
    this.openFileHandler = this.openFileHandler.bind(this);
    this.saveFile = this.saveFile.bind(this);
    this.saveAndClearFile = this.saveAndClearFile.bind(this);
    this.saveFileHandler = this.saveFileHandler.bind(this);
    this.clipboardHandler = this.clipboardHandler.bind(this);
    this.fontSizeSetter = this.fontSizeSetter.bind(this);
    this.fontHandler = this.fontHandler.bind(this);
  }

  extensionStripper(filename) {
    let periodIndex = filename.lastIndexOf(".");
    if(periodIndex === -1) {
      return filename;
    }
    let name = filename.slice(0, periodIndex);
    console.log(name);
    return name;
  }

  newFile(e, mode) {
    if(mode === "save") {
      this.props.appLauncherHandler(e, "Save File", this.saveAndClearFile, this.state.filename);
    }
    if(mode === "discard") {
      this.setState({filename: null});
      this.refs.notepadContents.value = "";
    }
  }

  newFileHandler(e) {
    this.props.appLauncherHandler(e, "New File", this.newFile, this.state.filename);
  }

  openFileError() {
    return(
      <span>
        <img width="32" src={this.props.warning_icon} draggable="false" alt={"Error"}/>
        <p>The file is not openable by Notepad.</p>
      </span>
    );
  }

  openFile(fullFilename, filename, filetype) {
    if(filetype !== "txt") {
      this.props.appLauncherHandler(null, "Popup Window", this.openFileError);
    }
    else {
      this.setState(
        {
          filename: filename
        }
      );
      let newContents = JSON.parse(sessionStorage.getItem(fullFilename));
      this.refs.notepadContents.value = newContents;
    }
  }

  openFileHandler(e) {
    this.props.appLauncherHandler(e, "Open File", this.openFile, this.state.filename);
  }

  saveFile(fullFilename) {
    let filename = this.extensionStripper(fullFilename);
    console.log(filename);
    this.setState(
      {
        filename: filename
      },
      function() {
        let contents = this.refs.notepadContents.value;
        sessionStorage.setItem(this.state.filename + ".txt", JSON.stringify(contents));
      }
    );
  }

  saveAndClearFile(fullFilename) {
    let filename = this.extensionStripper(fullFilename);
    this.setState(
      {
        filename: filename
      },
      function() {
        let contents = this.refs.notepadContents.value;
        sessionStorage.setItem(this.state.filename + ".txt", JSON.stringify(contents));
        this.setState({filename: null});
        this.refs.notepadContents.value = "";
      }
    );
  }

  saveFileHandler(e) {
    this.props.appLauncherHandler(e, "Save File", this.saveFile, this.state.filename);
  }

  clipboardHandler(mode) {
    let textArea = this.refs.notepadContents;
    if(mode === "paste") {
      textArea.focus();
    }
    else {
      textArea.select();
    }
    document.execCommand(mode);
  }

  fontSizeSetter(newSize) {
    this.setState(
      {
        fontSize: newSize
      }
    );
  }

  fontHandler(e) {
    this.props.appLauncherHandler(e, "Font Changer", this.fontSizeSetter, this.state.filename);
  }

  aboutHandler() {
    return(
      <span>
        <img width="32" src={this.props.info_icon} draggable="false" alt={"Info"}/>
        <p>It's a regular notepad application.</p>
      </span>
    );
  }

  helpHandler() {
    return(
      <span>
        <img width="32px" src={this.props.info_icon} draggable="false" alt={"Info"}/>
        <p> Just type in stuff and save it. </p>
      </span>
    );
  }

  render() {
    return(
      <div className="outsideWrapper">
        <MenuBar
          appLauncherHandler = {this.props.appLauncherHandler}
          newFileHandler = {this.newFileHandler}
          openFileHandler = {this.openFileHandler}
          saveFileHandler = {this.saveFileHandler}
          clipboardHandler = {this.clipboardHandler}
          fontHandler = {this.fontHandler}
          aboutHandler = {this.aboutHandler}
          helpHandler = {this.helpHandler}
        />
        <div id="notepadText">
          <textarea id="notepadInput" ref="notepadContents" data-testid="notepadInput"
           spellCheck="false" style={{fontSize: this.state.fontSize}}
          >
            {JSON.parse(sessionStorage.getItem(this.props.filename))}
          </textarea>
        </div>
      </div>
    )
  }
}

function MenuBar(props) {
  return (
    <div id="menuBar">
      <DropdownMenu
        buttonLabel = "File"
        menuItems = {[{name: "New", onClick: e => props.newFileHandler(e)},
                      {name: "Open", onClick: e => props.openFileHandler(e)},
                      {name: "Save", onClick: e => props.saveFileHandler(e)}]}
      />
      <DropdownMenu
        buttonLabel = "Edit"
        menuItems = {[{name: "Cut", onClick: () => props.clipboardHandler("cut")},
                      {name: "Copy", onClick: () => props.clipboardHandler("copy")}]}
                      // There used to be a copy button, but it didn't work
                      //  correctly due to browsers not allowing clipboard pasting
                      //  for security reasons
      />
      <DropdownMenu
        buttonLabel = "Help"
        menuItems = {[{name: "About", onClick: e => props.appLauncherHandler(e, "Popup Window", props.aboutHandler)},
                      {name: "Help", onClick: e => props.appLauncherHandler(e, "Popup Window", props.helpHandler)}]}
      />
    </div>
  );
}

export default Notepad;
